<div [hidden]="!isBodyEditor" class="text-left mb-2 relative">
    <material-radio-group [radioOptions]="languageOptions" [selectedValue]="language" (selectionChanged)="language = $event; checkBodyType()" [radioButtonClassList]="['inputRadioButton']" [radioGroupClassList]="['inputRadioGroup', '!flex', '!flex-row', '!gap-[25px]']"></material-radio-group>
    <ng-container *transloco="let translate">
        <div class="body-type absolute right-0 top-0" *ngIf="bodyTypeField?.id && language === 'raw'">
            <material-select [appearance]="'outline'" [options]="bodyTypeField.options" [errors]="bodyTypeField.errors" [placeholder]="translate(bodyTypeField.displayName)" [model]="bodyTypeField.value" [tailwindClasses]="bodyTypeField.tailwindClasses" [noHints]="bodyTypeField.hideHintElements" (modelChange)="bodyTypeField.value = $event"></material-select>
        </div>
    </ng-container>
</div>

<ng-container *ngIf="isBodyEditor">
    <ng-container [ngSwitch]="language">
        <ng-container *ngSwitchCase="'raw'">
            <ng-container *ngTemplateOutlet="rawTemplate"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'graphql'">
            <ng-container *ngTemplateOutlet="graphqlTemplate"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'jsonrpc'">
            <ng-container *ngTemplateOutlet="jsonrpcTemplate"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-container *ngIf="!isBodyEditor">
    <ng-container *ngTemplateOutlet="rawTemplate"></ng-container>
</ng-container>

<ng-template #rawTemplate>
    <div class="code-editor-container" [class]="tailwindClasses">
        <div class="code-editor-header" [hidden]="!language">
            <div class="code-editor-language" [textContent]="language"></div>
        </div>
        <div class="code-editor-content">
            <div class="line-numbers">
                <div class="line-number" *ngFor="let num of lineNumbers" [textContent]="num"></div>
            </div>
            <textarea class="code-area" [(ngModel)]="model" (ngModelChange)="modelChange.emit($event); updateLineNumbers($event)" [placeholder]="placeholder" [id]="id" [disabled]="!editable" (keypress)="errors && errors.splice(0, 1)" spellcheck="false" autocomplete="off" autocorrect="off" autocapitalize="off"></textarea>
        </div>
    </div>
    <div *ngIf="required && !(errors && errors.length > 0)" class="required-field">
        <strong>
            <span>*</span>
            Required
        </strong>
    </div>
    <div *ngIf="errors && errors.length > 0" class="error-message" [attr.title]="errors" [textContent]="errors">
    </div>
</ng-template>

<ng-template #graphqlTemplate>
    <div class="graphQL-container row">
        <div class="col-6">
            <app-code-editor [model]="queryField?.value" [placeholder]="queryField?.displayName" [id]="queryField?.id" [required]="queryField?.required" [editable]="editable" [errors]="errors" [language]="'QUERY'" [theme]="theme" [tailwindClasses]="tailwindClasses" (modelChange)="queryField.value = $event"></app-code-editor>
        </div>
        <div class="col-6">
            <app-code-editor [model]="variablesField?.value" [placeholder]="variablesField?.displayName" [id]="variablesField?.id" [required]="variablesField?.required" [editable]="editable" [errors]="errors" [language]="'GRAPHQL VARIABLES (JSON)'" [theme]="theme" [tailwindClasses]="tailwindClasses" (modelChange)="variablesField.value = $event"></app-code-editor>
        </div>
    </div>
</ng-template>

<ng-template #jsonrpcTemplate>
    <div class="graphQL-container row">
        <div class="col-6">
            <app-code-editor [model]="rpcMethodField?.value" [placeholder]="rpcMethodField?.displayName" [id]="rpcMethodField?.id" [required]="rpcMethodField?.required" [editable]="editable" [errors]="errors" [language]="'JSON-RPC METHOD'" [theme]="theme" [tailwindClasses]="tailwindClasses" (modelChange)="rpcMethodField.value = $event"></app-code-editor>
        </div>
        <div class="col-6">
            <app-code-editor [model]="rpcParamsField?.value" [placeholder]="rpcParamsField?.displayName" [id]="rpcParamsField?.id" [required]="rpcParamsField?.required" [editable]="editable" [errors]="errors" [language]="'JSON-RPC PARAMS'" [theme]="theme" [tailwindClasses]="tailwindClasses" (modelChange)="rpcParamsField.value = $event"></app-code-editor>
        </div>
    </div>
</ng-template>
